var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLawNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 221 218",
    style: {
      enableBackground: "new 0 0 221 218"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:#EC1C24;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.03,104.92c-0.68-10.23-9.17-18.33-19.57-18.33c-10.4,0-18.89,8.1-19.57,18.33h-0.07v5.55h0.46h38.34 h0.46v-5.55H135.03z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.89,
    y: 111.63,
    className: "st1",
    width: 51.14,
    height: 3.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.81,
    y: 115.41,
    className: "st1",
    width: 43.29,
    height: 17.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 115.46,
    cy: 76.95,
    r: 8.95
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "119.75,93.98 116.27,86.5 115.35,86.6 114.29,86.5 110.81,93.98 112.56,94.8 115.28,88.97 118,94.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 93.81,
    y: 115.44,
    className: "st0",
    width: 43.29,
    height: 0.92
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawNew);
export default __webpack_public_path__ + "static/media/lawNew.fcfac9d50bc2f08925e117d6c044ec92.svg";
export { ForwardRef as ReactComponent };